const SkeletonCard = () => {
  return (
    <div className="flex flex-col bg-m2-surface-lowest rounded-lg border border-m2-outline-variant overflow-hidden animate-pulse">
      <div className="h-40 bg-m2-surface-highest" />
      <div className="p-3 space-y-3">
        <div className="space-y-2">
          <div className="h-5 bg-m2-surface-highest rounded w-5/6" />
          <div className="h-5 bg-m2-surface-highest rounded w-2/3" />
        </div>
        <div className="h-3 bg-m2-surface-highest rounded w-1/3" />
        <div className="h-5 bg-m2-surface-highest rounded w-1/2" />
        <div className="h-4 bg-m2-surface-highest rounded w-20" />
        <div className="flex gap-1">
          <div className="h-5 bg-m2-surface-highest rounded w-16" />
          <div className="h-5 bg-m2-surface-highest rounded w-14" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;
